/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { useFormContext } from "react-hook-form";
import { Heading, Input, Label } from "@nordcloud/gnui";
import { CloudAccountCloudProvider } from "~/generated/graphql";
import { FormGroup } from "~/components";
import { FormField } from "../formConfig";
import {
  ACCOUNT_DESCRIPTION_PLACEHOLDER,
  ACCOUNT_ENVIRONMENT_PLACEHOLDER,
  ACCOUNT_NAME_PLACEHOLDER,
} from "./constants";

type Props = {
  provider: CloudAccountCloudProvider;
  displayNameLabel?: string;
};

export function AccountDetailsFields({
  provider,
  displayNameLabel = "Account Name",
}: Props) {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      <Heading level={3} marginBottom="spacing05">
        Account details
      </Heading>
      <input
        type="hidden"
        id="provider"
        {...register(FormField.provider)}
        value={provider}
      />
      <FormGroup error={errors[FormField.displayName]}>
        <Label name={displayNameLabel} />
        <Input
          id="displayName"
          {...register(FormField.displayName)}
          placeholder={`e.g. ${ACCOUNT_NAME_PLACEHOLDER}`}
        />
      </FormGroup>
      <FormGroup error={errors[FormField.description]}>
        <Label name="Description" htmlFor="description" />
        <Input
          id="description"
          {...register(FormField.description)}
          placeholder={`e.g. ${ACCOUNT_DESCRIPTION_PLACEHOLDER}`}
        />
      </FormGroup>
      <FormGroup error={errors[FormField.environment]}>
        <Label name="Environment" htmlFor="environment" />
        <Input
          id="environment"
          {...register(FormField.environment)}
          placeholder={`e.g. ${ACCOUNT_ENVIRONMENT_PLACEHOLDER}`}
        />
      </FormGroup>
    </>
  );
}
